export default {
  severities: 'Schweregrade',
  allSeverities: 'Alle Schweregrade',
  doesIncludeHiddenAlarms: 'Ausgeblendete Alarme einbeziehen',
};
